export default {
  OVERRIDE: 'OVERRIDE',
};
